import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GdprComponent } from './gdpr/gdpr.component';
import { GdprModalComponent } from './gdpr-modal/gdpr-modal.component';
import { SosCoreModule, SystemIconModule, MenuModule, ButtonModule, InputModule } from '@serviceos-ng/core';
import { FormsModule } from '@angular/forms';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    GdprComponent,
    GdprModalComponent
  ],
  imports: [
    CommonModule,
    SosCoreModule,
    SystemIconModule,
    MenuModule,
    ButtonModule,
    FormsModule,
    InputModule,
    NgbAccordionModule
  ],
  exports: [
    GdprComponent
  ]
})
export class GDPRModule { }
